export enum Codec {
  Opus = "opus",
  PCMU = "pcmu"
}

export enum CALL_STATE {
  CONNECTING = "Connecting",
  READY = "Ready",
  ON_CALL = "On call",
  OFFLINE = "",//Offline
}